export default "__VITE_ASSET__BtdW0EEO__"